export default __webpack_public_path__ + "static/media/carrer.2a94ea2a.png";